import React from 'react';
import { Container, Image , Button} from 'react-bootstrap';
import Error from '../img/404error.svg';

function NotFoundPage() {
    return (
        <Container className="img-align error-page" mx-auto fluid>
            <Image src={Error} className="" />
            <h3>little lost there buddy, here let me help you back</h3>
            <Button variant="danger" href='/' > Home</Button>
        </Container>
    );
}

export default NotFoundPage;